
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.112 15.75c0-.991-.885-1.9-2.112-1.9s-2.112.909-2.112 1.9c0 .991.885 1.9 2.112 1.9s2.112-.909 2.112-1.9zM4 12.15c2.045 0 3.812 1.554 3.812 3.6 0 2.047-1.767 3.6-3.812 3.6S.188 17.797.188 15.75c0-2.046 1.767-3.6 3.812-3.6z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.462 2.813v8.25c0 .124.134.25.269.25h1.01c.134 0 .269-.126.269-.25v-8.25c0-.126-.135-.25-.27-.25H3.73c-.134 0-.268.124-.268.25z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.423 3.563L4.606.687c-.135-.25-.606-.25-.74 0L2.047 3.563c-.135.25.067.626.337.626h3.567c.404 0 .606-.313.471-.625zM5.01 28.188v-7.75c0-.125-.135-.25-.27-.25H3.73c-.134 0-.268.125-.268.25v7.75c0 .125.134.25.269.25h1.01c.134 0 .269-.125.269-.25z","fill":"#fff"}}),_c('path',{attrs:{"d":"M2.048 27.438l1.817 2.875c.135.25.606.25.74 0l1.818-2.875c.135-.25-.067-.625-.336-.625H2.519c-.404 0-.606.375-.47.625z","fill":"#fff"}})])
          )
        }
      }
    